export default "__VITE_ASSET__f167b858__"